export default "__VITE_ASSET__BpmJPS9Z__"